export const getErrorsFor = key => state => (state.validation[key] ? state.validation[key] : {});
